import { API as r } from "../../api/api.js";
const i = (e) => async (t) => {
  const { getState: n } = e, { tokenHandlers: { spacePermissionTokenHandler: s, subscriptionTokenHandler: o } } = n();
  return await r.getOrCreateInstance().document().listDocuments(t, s, o);
};
export {
  i as listDocuments
};
